import { render, staticRenderFns } from "./EditEmployeeButton.vue?vue&type=template&id=b4ece1b4&"
import script from "./EditEmployeeButton.vue?vue&type=script&lang=js&"
export * from "./EditEmployeeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports